import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import Login from './components/Login';
import Interview from './components/Interview';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import { loginRequest } from './msalConfig';
import { ThemeProvider, createTheme } from '@mui/material/styles';

function App() {
    const [themeMode, setThemeMode] = useState('light');
    
    const theme = createTheme({
        palette: {
            mode: themeMode,
            primary: {
                main: '#424242',
            },
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/interview" element={<Interview />} />
                    <Route path="/admin-login" element={<AdminLogin />} />
                    <Route path="/admin-dashboard/*" element={
                        <MsalAuthenticationTemplate interactionType="redirect" authenticationRequest={loginRequest}>
                            <AdminDashboard themeMode={themeMode} setThemeMode={setThemeMode} />
                        </MsalAuthenticationTemplate>
                    } />
                </Routes>
            </Router>
        </ThemeProvider>
    );
}

export default App;
